import { render, staticRenderFns } from "./WebhookEventsView.vue?vue&type=template&id=386476d2"
import script from "./WebhookEventsView.vue?vue&type=script&lang=js"
export * from "./WebhookEventsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports